<template>
<div class="bg-login">

  <!-- Container -->
  <div class="bg-login-main">
    <section class="container">
      <div class="row bg-login-inner">
        <div class="form-title">{{ $t('signup.signup.title_expired') }}</div>
      </div>
      <div class="row bg-login-inner">
        <form class="login form">
          <!-- name -->
          <template v-if="authuser && authuser.invite_id">
          <div class="notification-box alert" v-html="$t('signup.signup.expired_messeage')"></div>
          </template>
          <template v-else-if="authuser && !authuser.invite_id">
          <div class="notification-box alert" v-html="$t('signup.signup.expired_account_messeage')"></div>
          </template>

        </form>
      </div>
    </section>
    
  </div>
  <div class="bg-login-bottom">
    <div class="container">
      <div class="row bg-login-inner">
        <div class="label-title">{{ $t('signup.signup.label_payment') }}</div>
        <button type="button" class="button button-default next" @click="purchase">
          <span>{{ $t('signup.signup.register_step3') }}</span>
        </button>
      </div>
    </div>
  </div>
  <!-- /Container -->
</div>

</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {api, countrieList} from "../../config";

  export default {
    data() {
      return {
        loading: false,
        resent: false,
        csrf: "",
        error: {
          displayname: '',
        },
        form: {
          displayname: ''
        },
        authuser: null,
        countries: countrieList,
        selectCountry: { val: 'JP', name: "Japan" }
      };
    },
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ])
    },
    created: function () {
      const self = this
      axios.get(api.currentUser, {
        params: { type: 'signup'}
      })
      .then((resp) => {
        self.authuser = resp.data;
        self.$store.dispatch('setAuthUser', resp.data)
      });
    },
    methods: {
      purchase() {
        this.$store.dispatch('showLoading', true)
        // window.sessionStorage.removeItem(appName);
        axios.post(api.logout).then(() => {
          this.$store.dispatch('unsetAuthUser')
          this.$store.dispatch('unsetProfile')
          this.$store.dispatch('unsetLanguage')
          this.$store.dispatch('unsetLessons')
          this.$store.dispatch('unsetLessonData')
          this.$store.dispatch('unsetLessonContent')
          .then(() => {
            
            this.$store.dispatch('showLoading', false);
            window.location.href = window.global.jsl_method_url + '/apps/purchase';
          });
        });
      }
    }
  }
</script>

